import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import useSiteContext from 'hooks/useSiteContext';

import Social from './Social';

const SocialContainer = ({ course, ...props }) => {
  const { t } = useTranslation();
  const link = course.moodle.isMoodle
    ? `${process.env.REACT_APP_WEB_URL}/moodle/${course.accessCode}`
    : `${process.env.REACT_APP_WEB_URL}/join/${course.accessCode}`;
  const { isInNative, isInTeams } = useSiteContext();
  const [isOnMobile] = useState(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream; // !window.MSStream is to not incorrectly detect IE11
    const isAndroid = /android/i.test(userAgent);
    const isWindows = /windows phone/i.test(userAgent);
    return isIOS || isAndroid || isWindows || isInNative;
  }, []);
  return (
    <Social
      isInTeams={isInTeams}
      isOnMobile={isOnMobile}
      link={link}
      t={t}
      {...props}
    />
  );
};

SocialContainer.propTypes = {
  course: PropTypes.object.isRequired,
};

export default SocialContainer;
